<template>
    <Modal title="Edit Event" :can-close-via-backdrop="false">
        <button
            type="button"
            class="
                py-2
                pl-4
                pr-8
                flex flex-row
                items-center
                text-left
                gap-2
                cursor-pointer
                hover:bg-gray-100
                rounded-lg
                w-full
            "
        >
            <ion-icon name="create-outline" class="text-xl mr-2"></ion-icon>
            Edit Event
        </button>

        <template #body="{ close }">
            <form :action="api" method="post">
                <input type="hidden" name="_token" :value="$root.csrfToken" />
                <input type="hidden" name="_method" value="PUT" />
                <input
                    type="hidden"
                    name="teamId"
                    :value="props.event.team_id"
                />
                <div class="my-2">
                    <label for="name" class="block font-semibold my-2 text-sm">
                        Title
                    </label>
                    <new-input
                        required
                        maxlength="128"
                        label="Name"
                        name="title"
                        placeholder="Event title"
                        :value="state.event.title"
                    ></new-input>
                </div>
                <div class="my-2">
                    <label
                        for="description"
                        class="block font-semibold my-2 text-sm"
                    >
                        Description (optional)
                    </label>
                    <new-textarea
                        label="Description (optional)"
                        name="description"
                        placeholder="Event Description (optional)"
                        :value="state.event.description"
                    ></new-textarea>
                </div>
                <div class="my-2">
                    <label
                        for="description"
                        class="block font-semibold my-2 text-sm"
                    >
                        Time
                    </label>
                    <new-input
                        type="datetime-local"
                        required
                        label="Time"
                        name="time"
                        placeholder="Time"
                        :value="state.event.time"
                    ></new-input>
                </div>

                <div class="my-2">
                    <label
                        for="room_id"
                        class="block font-semibold my-2 text-sm"
                    >
                        Meeting Room
                    </label>
                    <app-select
                        name="room_id"
                        :model-value="state.event.room_id"
                        @update:model-value="handleRoomChange"
                    >
                        <option value="-1" default selected>Offline</option>
                        <option
                            :value="room.room_id"
                            v-for="room in rooms"
                            :key="room.room_id"
                        >
                            {{ room.room_name }}
                        </option>
                    </app-select>
                </div>

                <div class="my-2" v-if="state.isOfflineRoom">
                    <label
                        for="description"
                        class="block font-semibold my-2 text-sm"
                    >
                        Location
                    </label>
                    <new-input
                        type="text"
                        required
                        label="Location"
                        name="location"
                        placeholder="Location"
                        :value="state.event.location"
                    ></new-input>
                </div>

                <div class="mt-8 flex items-center gap-4 justify-end">
                    <app-button
                        @click="close"
                        type="button"
                        class="border border-accent text-accent !bg-white"
                    >
                        Cancel
                    </app-button>
                    <app-button type="submit" class="!bg-primary text-white">
                        Update Event
                    </app-button>
                </div>
            </form>
        </template>
    </Modal>
</template>
<script setup>
import { defineProps, reactive } from "vue";
import Modal from "./Modal";

const props = defineProps({
    api: {
        type: String,
        required: true,
    },
    event: {
        type: Object,
        required: true,
    },
    rooms: {
        type: Array,
        required: true,
    },
    teamId: {
        type: Number,
        required: true,
    },
});

const state = reactive({
    isOfflineRoom: props.event.room_id == -1,
    event: {
        ...props.event,
        time: new Date(props.event.time).toISOString().slice(0, 16),
    },
});

function handleRoomChange(roomId) {
    if (roomId == -1) {
        state.isOfflineRoom = true;
    } else {
        state.isOfflineRoom = false;
    }
}
</script>
